<template>
  <div>
    <div class="modal-box">
      <header class="modal-card-head">
        <span class="modal-card-title">Search for a member</span>
        <button
          class="delete"
          aria-label="close"
          @click="close"
        />
      </header>
      <section class="modal-card-body">
        <div class="search-desktop">
          <span class="icon is-right">
            <i class="far fa-search" />
          </span>
          <input
            v-model="searchCriteria"
            placeholder="Start type a name"
            class="input-search"
            type="text"
          >
        </div>
        <div
          v-for="member in chunkedMembers"
          class="box p-1 mt-4 is-radiusless"
        >
          <div class="border-bottom is-flex flex-row space-between relative align-center p-1">
            <div class="is-flex flex-row align-center">
              <div class="ml-4">
                <router-link
                  :to="`/players/${member.ahlid}`"
                  class="mr-1 is-size-7-touch"
                >
                  {{ member.first }} {{ member.middle }} {{ member.last }}
                </router-link>
                <small class="has-text-dark mr-1">
                  {{ member.ahlid }}
                </small>
              </div>
            </div>
            <div>
              <a
                v-if="!member.isBanned"
                class="button is-small button-tools"
                @click="addMember(member)"
              >
                Add member
              </a>
            </div>
            <div
              v-if="member.isBanned"
              class="mr-1 is-size-7-touch"
            >
              Reason: {{ member.reason }}<br>
              End Date: {{ member.duration }}<br>
              <a class="tag is-danger pointer">
                Banned
              </a>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button"
          @click.prevent="close"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  let cancel

  export default {
    props: ['token'],
    data () {
      return {
        searchCriteria: '',
        members: []
      }
    },
    computed: {
      chunkedMembers () {
        return this.members.splice(0, 10)
      }
    },
    watch: {
      searchCriteria (val) {
        if (val) {
          this.search()
        } else this.members = []
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      search () {
        if (cancel) {
          cancel()
        }
        this.$axios({
          method: 'POST',
          url: `admin/members/membersearch`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          cancelToken: new axios.CancelToken(function executor(c) {
            cancel = c
          }),
          data: {
            token: this.token || '',
            'criteria': this.searchCriteria
          }
        })
          .then((res) => {
            this.members = res.data.members
          })
          .catch((error) => {
            console.log(error)
          })
      },
      addMember (member) {
        this.$emit('addMemberId', member)
      }
    }
  }
</script>
